import React from 'react';
import { LinkButton, ListItem } from '@ds';
import { DSKeyIcon } from '@design-system/icons';
import UserMenuApiKeyCopy from './UserMenuApiKeyCopy';

import styles from './UserMenuApiKey.module.scss';
import { useUserMenuContext } from '../../userMenuContext';

const UserMenuApiKeyMenuItem = () => {
  const { closeMainMenu } = useUserMenuContext();

  return (
    <div data-test="user-menu-api-key-link">
      <ListItem>
        <ListItem.PrefixContainer>
          <ListItem.Icon Icon={<DSKeyIcon />} />
        </ListItem.PrefixContainer>
        <ListItem.Text primary="API Key" />
        <ListItem.Submenu
          offset="0 2px 0 0"
          iconSize="16px"
          placement="left-start"
        >
          <div className={styles.apiKeyManageContainer}>
            <UserMenuApiKeyCopy />
            <LinkButton
              type="tertiary"
              to="/account-settings/apiKeys"
              text="Manage API keys"
              accented
              fullWidth
              className={styles.apiKeyManageBtn}
              onClick={closeMainMenu}
            />
          </div>
        </ListItem.Submenu>
      </ListItem>
    </div>
  );
};

export default UserMenuApiKeyMenuItem;
